import React, { useState, useEffect } from 'react';
import Modal from '../modal/Modal';
import _ from 'lodash';

function BulkSetInventoryModal({ isOpen, onCancel, onConfirm, ...rest }) {
  const [inventory, setInventory] = useState('');

  useEffect(() => {
    if (!isOpen) {
      setInventory('');
    }
  }, [isOpen]);

  const _setInventory = (inventory) => {
    if (inventory.trim() === '') {
       setInventory('');
    } else {
      const casted = inventory === '0' ? 0 : parseInt(inventory);

      if (!_.isFinite(casted)) return;

      setInventory(casted);
    }
  };

  return (
    <Modal
      title="Bulk Set Inventory Levels"
      isOpen={isOpen}
      buttons={[
        {
          style: 'white',
          text: 'Cancel',
          onClick: () => {
            onCancel();
          }
        },
        {
          style: 'black',
          text: 'Set',
          onClick: () => {
            if (inventory === '') {
               onConfirm('');
            } else {
              onConfirm(parseInt(inventory));
            }
          },
        }
      ]}
      onRequestClose={() => {
        onCancel();
      }}
      autoFocus={false}
      {...rest}
    >
      <h3>Inventory Level</h3>
      <input
        type="text"
        value={inventory}
        onChange={e => _setInventory(e.target.value)}
        autoFocus={true}
      />
    </Modal>
  );
}

BulkSetInventoryModal.defaultProps = {
  isOpen: false,
  onCancel: () => {},
  onConfirm: () => {},
};

export default BulkSetInventoryModal;
